import { ISeekAccount } from '../../NewUI/Components/Multiposter/types';
import { useState, useEffect } from 'react';

export const useSeekAccounts = ({ jobId }: { jobId: string | null }) => {
  const [seekAccounts, setSeekAccounts] = useState<ISeekAccount[]>([]);

  useEffect(() => {
    const getSeekAccounts = async () => {
      try {
        const response = await fetch(`/api/v4/seek/jobs/${jobId}/accounts`);
        const { accounts } = await response.json();
        setSeekAccounts(accounts);
      } catch (error) {
        console.log(error);
      }
    };
    getSeekAccounts();
  }, [jobId]);

  return { seekAccounts, setSeekAccounts };
};
